import React, { useEffect, useState } from "react";
import { Table, Container } from "react-bootstrap";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import config from "../config.js";

const SpecificationTable = () => {
  const [specifications, setSpecifications] = useState([]);
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [filteredSpecifications, setFilteredSpecifications] = useState([]);
  const navigate = useNavigate();

  // ✅ Fetch all specifications data
  useEffect(() => {
    axios
      .get(`${config.API_BASE_URL}/api/specificationdatapro`)
      .then((response) => {
        setSpecifications(response.data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, []);

  // ✅ Fetch product details
  useEffect(() => {
    axios
      .get(`${config.API_BASE_URL}/api/specificationdata/${id}`)
      .then((response) => {
        if (response.data.length > 0) {
          setProduct(response.data[0]);
        }
      })
      .catch((error) => {
        console.error("Error fetching product:", error);
      });
  }, [id]);

  // ✅ Filter only specifications with the same `pro_id`
  useEffect(() => {
    if (product && specifications.length > 0) {
      const filteredData = specifications.filter(
        (item) => item.pro_id === product.pro_id
      );
      setFilteredSpecifications(filteredData);
    }
  }, [product, specifications]);

  // ✅ Function to handle row click
  const handleRowClick = (specId) => {
    console.log("Navigating to /cart/" + specId); // ✅ Debugging log
    navigate(`/cart/${specId}`);
    window.location.reload();
  };
  return (
    <Container>
      <div className="specification-wrapper">
        <p className="quintity">Specifications</p>
        <div className="table-wrapper">
          <Table bordered responsive className="spec-table">
            <thead className="table-header">
              <tr>
                <th>Model</th>
                <th>Wattage</th>
                <th>Initial Lumens</th>
                <th>Stable Lumens</th>
                <th>RA</th>
                <th>Beam Angle</th>
                <th>Life</th>
                <th>Lamp Size H1</th>
                <th>Lamp Size H2</th>
                <th>Lamp Size D</th>
              </tr>
            </thead>
            <tbody>
              {filteredSpecifications.map((item, index) => (
                <tr
                  key={index}
                  onClick={() => handleRowClick(item.id)} // ✅ Click event added
                  style={{ cursor: "pointer", backgroundColor: "#f8f9fa" }} // ✅ Cursor pointer added
                >
                  <td>{item.product_model}</td>
                  <td>{item.wattage}</td>
                  <td>{item.initial_lumen}</td>
                  <td>{item.stable_lumen}</td>
                  <td>{item.ra}</td>
                  <td>{item.beam_angle}</td>
                  <td>{item.life}</td>
                  <td>{item.lamp_size_h1}</td>
                  <td>{item.lamp_size_h2}</td>
                  <td>{item.lamp_size_d}</td>
                </tr>
              ))}
              {filteredSpecifications.length === 0 && (
                <tr>
                  <td colSpan="10" className="text-center">
                    No specifications found for this product.
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>
    </Container>
  );
};

export default SpecificationTable;
